import { useCallback, useState } from "react";
import { useEffect } from "react";

import api from "../../../../api/api";

const useEmailSignature = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getEmailSignatures = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/api/firmsetting-page/email-signature/");
      setData(response.data);
    } catch (error) {
      setError(error);
    }
  }, []);

  useEffect(() => {
    getEmailSignatures();
  }, [getEmailSignatures]);

  return { data, loading, error, refetch: getEmailSignatures };
};

export default useEmailSignature;

const useSaveEmailSign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const saveEmail = async (payload) => {
    setLoading(true);
    try {
      const response = await api.post("/api/firmsetting-page/email-signature/", payload);
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { saveEmail, loading, error, success };
};

export { useSaveEmailSign };

const useEditEmailSign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const editEmailSign = async (payload) => {
    setLoading(true);
    try {
      const response = await api.patch("/api/firmsetting-page/email-signature/", payload);
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { editEmailSign, loading, error, success };
};

export { useEditEmailSign };

const useDeleteEmailSign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const deleteEmailSign = async (payload) => {
    setLoading(true);
    try {
      const response = await api.delete("/api/firmsetting-page/email-signature/", {
        params: {
          id: payload?.id,
        },
      });
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { deleteEmailSign, loading, error, success };
};

export { useDeleteEmailSign };
